import { validateBarcode } from "./../components/global/barcode/AssetsBarcode";
import { getValuesFromBetweenNumber } from "./handleOnChange";
import { string, number } from "yup";
import metaEnv from "../helper/metaEnv";

export const enum EHelperText {
    UPDATED_SUCCESS = "อัปเดตข้อมูลสำเร็จ",
    UPDATED_ERROR = "อัปเดตข้อมูลไม่สำเร็จ",
    REQUIRED = "กรุณากรอก ",
    MATCH_PASSWORD = "กรุณายืนยันรหัสผ่านให้ตรงกัน ",
    REQUIRED_SELECT = "กรุณาระบุ ",
    REQUIRED_ACCEPT = "กรุณายอมรับ ",
    PATTERN = "รูปแบบไม่ถูกต้อง",
    MIN = "อย่างน้อย ",
    MAX = "สูงสุด ",
    LETTER = "ตัวอักษร",
    PASSWORD = "รหัสผ่าน",
    NUMERIC = "ตัวเลข",
    TYPE = "ประเภทข้อมูลไม่ถูกต้อง ",
    NUMBER = "เฉพาะตัวเลขเท่านั้น ",
    STRING = "เฉพาะตัวอักษรเท่านั้น ",
    AN_ERROR_OCCURRED = "เกิดข้อผิดพลาดกับ "
}

const authLoginSchemaBase = {
    username: string().required(EHelperText.REQUIRED + "ชื่อผู้ใช้"),
    password: string().required(EHelperText.REQUIRED + "รหัสผ่าน")
};

const productCreateSchemaBase = {
    sku: string().required(EHelperText.AN_ERROR_OCCURRED + "รหัสสินค้า"),
    name_th: string().required(EHelperText.REQUIRED + "ชื่อสินค้า ภาษาไทย"),
    name_en: string().required(EHelperText.REQUIRED + "ชื่อสินค้า ภาษาอังกฤษ"),
    name_odinary: string().required(EHelperText.REQUIRED + "ชื่อสินค้า สามัญ"),
    category: string().required(EHelperText.REQUIRED_SELECT + "หมวดหมู่สินค้า"),
    unit: string().required(EHelperText.REQUIRED_SELECT + "หน่วยสินค้า"),
    weight_unit: number().required(EHelperText.REQUIRED + "น้ำหนัก/หน่วย"),
    diameter: number().required(EHelperText.REQUIRED + "เส้นผ่านศูนย์กลาง"),
    circumference: number().required(EHelperText.REQUIRED + "เส้นรอบวง"),
    length: string().required(EHelperText.REQUIRED + "ความยาว")
};

//TemperatureSchema have to use with ( onchange regexFilter onChangeBetweenNumber )
export const TemperatureSchema = (isRequired: boolean) => {
    const resData = string();
    if (isRequired) resData.required(EHelperText.REQUIRED);
    return resData.test("is-temperature", "ตัวเลขไม่ถูกต้อง", (value) => {
        const lastDigit = value?.charAt(value.length - 1);
        if (lastDigit === "." || lastDigit === "-") return false;
        if (!value && !isRequired) return true;
        const { start, end } = getValuesFromBetweenNumber(value || "");
        if (!start?.toString() || isNaN(start)) return false;
        if (end?.toString() && end < start) return false;
        return true;
    });
};

//EAN8 EAN13
// have to validate more that EAN8 = 8 digit , EAN13 = 13 digit
export const BarcodeScheman = (isRequired: boolean) => {
    const resData = string();
    if (isRequired) resData.required(EHelperText.REQUIRED);
    return resData
        .min(8, "รูปแบบไม่ถูกต้อง")
        .max(13, "รูปแบบไม่ถูกต้อง")
        .test("is-barcode", "ตัวเลขไม่ถูกต้อง", (value) => {
            if (!value && !isRequired) return true;
            if (!value || !validateBarcode(value)) return false;
            return true;
        });
};

//check if any object props have value
export const isGotValuesInObject = (obj: object, ignoreKeys?: Array<string>): boolean => {
    for (const [key, value] of Object.entries(obj)) {
        if (isObject(value)) {
            const result = isGotValuesInObject(value, ignoreKeys);
            if (result === true) return true;
        } else {
            if (Array.isArray(value)) {
                if (value.length) {
                    if (!(ignoreKeys && ignoreKeys.includes(key))) {
                        metaEnv.isDev && console.log("isGotValuesInObject. found array length", { key, value });
                        return true;
                    }
                }
            } else if (value || value === 0) {
                if (!(ignoreKeys && ignoreKeys.includes(key))) {
                    metaEnv.isDev && console.log("isGotValuesInObject. found", { key, value, ignoreKeys });
                    return true;
                }
            }
        }
    }
    return false;
};

export const isObject = (value: any) => !!(typeof value === "object" && !Array.isArray(value) && value !== null);

//use this to react hook form resolver
export const productCreateSchemaShape = productCreateSchemaBase;
export const authLoginSchemaShape = authLoginSchemaBase;
